import { createComponent } from '@workday/canvas-kit-react/common';
// eslint-disable-next-line no-restricted-imports
import { FormField, FormFieldProps } from '@workday/canvas-kit-react/form-field';
import { createStyles } from '@workday/canvas-kit-styling';
import { WcpStyles } from '@workday/wcp-tokens';

const formFieldStyles = createStyles({
  marginBottom: 0,
  label: {
    color: WcpStyles.color.text.default,
  },
});

export const ThemedFormField = createComponent(FormField)({
  displayName: 'Canvas.FormField',
  Component: (props: FormFieldProps, ref, Element) => <Element ref={ref} className={formFieldStyles} {...props} />,
  subComponents: {
    Field: FormField.Field,
    Hint: FormField.Hint,
    Input: FormField.Input,
    Label: FormField.Label,
  },
});
